import React, { Fragment } from 'react';
import Head from 'next/head';
import cn from 'classnames';

import Footer from './Footer';
import styles from './styles/BrandPages.module.scss';

/**
 * About Component
 * @param {*} props
 */
export default function About() {
  return (
    <Fragment>
      <Head>
        <meta
          name="description"
          content="At Ideas Come To Life, we believe that supporting small businesses
          is the key to creating prosperity. For this reason, we have built
          and are working on technology platforms that make it easier for
          small businesses to set up their businesses digitally and connect
          with customers. Through our collective experiences in running
          small businesses as well as being a small business, Ideas Come To
          Life believes that we can create a prosperous future together by
          making the tools that small businesses need to succeed in a
          digital world more accessible to all."
        />
        <meta
          name="og:description"
          content="At Ideas Come To Life, we believe that supporting small businesses
          is the key to creating prosperity. For this reason, we have built
          and are working on technology platforms that make it easier for
          small businesses to set up their businesses digitally and connect
          with customers. Through our collective experiences in running
          small businesses as well as being a small business, Ideas Come To
          Life believes that we can create a prosperous future together by
          making the tools that small businesses need to succeed in a
          digital world more accessible to all."
        />
      </Head>

      <div className={cn(styles.backgroundTitle, 'theme-background')}>
        <h1>Creating Prosperity through Small Businesses</h1>
      </div>
      <div className={cn(styles.sectionContent, 'content-placeholder')}>
        <div className={styles.aboutUsHolder}>
          <div className={cn(styles.subSection, styles.centeredSection)}>
            <p>
              At Ideas Come To Life, we believe that supporting small businesses
              is the key to creating prosperity. For this reason, we have built
              and are working on technology platforms that make it easier for
              small businesses to set up their businesses digitally and connect
              with customers. Through our collective experiences in running
              small businesses as well as being a small business, Ideas Come To
              Life believes that we can create a prosperous future together by
              making the tools that small businesses need to succeed in a
              digital world more accessible to all.
            </p>
          </div>

          <div className={styles.subSection}>
            <h4>ICTLife Merchant</h4>
            <h1>Create an Online Profile for your Business</h1>
            <p>
              Using the Merchant App, you can create an Online Profile for your
              business which will provide you with an opportunity to provide the
              following information
            </p>
            <div className={styles.list}>
              <div className={styles.listItem}>
                <div className={styles.number}>1</div>
                <div>
                  What products, services or experiences does your business
                  provide?
                </div>
              </div>
              <div className={styles.listItem}>
                <div className={styles.number}>2</div>
                <div>
                  What is your business location and contact phone number?
                </div>
              </div>
              <div className={styles.listItem}>
                <div className={styles.number}>3</div>
                <div>
                  How did you start your business? What makes your business
                  products, services or experiences unique? What is your
                  thinking about customer service? Show some pictures of your
                  business from the past and present to showcase how far your
                  business has come
                </div>
              </div>
            </div>
            <p>
              Once you have created your online business profile, you will have
              a website which you can share with your customers and through
              which you can communicate with your customers.
            </p>
          </div>

          <div className={styles.subSection}>
            <h4>ICTLife Merchant</h4>
            <h1>Create &amp; Share Posts about your Business</h1>
            <p>
              The ICTLife Merchant Account provides your business with the
              ability to create beautiful posts and then share the posts through
              social media such as Whatsapp, Facebook, Instagram or Twitter as
              well as generates a unique web link which you can email or SMS to
              your customers. The posts that you create are saved in your
              business profile and do not expire. This allows you to create a
              comprehensive business profile over time as your customers can
              view all the posts that you’ve made over time.
            </p>
          </div>

          <div className={styles.subSection}>
            <h4>ICTLife Merchant</h4>
            <h1>Connect and Interact with your Customers</h1>
            <p>
              When you create posts and share them with your customers, they are
              able to interact with you by commenting on your posts as well as
              by liking or sharing your post with their friends. This gives your
              business the ability to connect with customers while making it
              easier for your customers to refer your business to their friends.
              For example, a hairdresser posting their latest hairstyle will
              have the ability to reply to any comments that come in after
              putting in their post. The customers that the post is shared with
              can also share the post with their friends increasing the reach of
              the hairdresser’s post. Finally, all interactions with customers
              are organized on a per customer basis, enabling you to create a
              profile of your customers over time.
            </p>
          </div>

          <div className={cn(styles.subSection, styles.centeredSection)}>
            <h1>About the Company</h1>
            <p>
              ICTLife is a product of Ideas Come To Life Ltd, a Kenyan
              technology company that is working on the mission of creating “A
              Prosperous Africa” by building infrastructure to support commerce
              across Africa. We believe that we have a unique opportunity to
              deliver technology that will transform African business outcomes
              and are working hard to realize that dream.
            </p>
            <p>
              Ideas Come To Life Ltd was founded in 2018 by Eston Kimani who is
              an experienced technology entrepreneur and has been involved as a
              founder or co-founder of AfricasTalking, Focus Mobile and
              DukaConnect. He is a graduate of the Starehe Boys Centre,
              Massachusetts Institute of Technology and the UNCTAD-Alibaba
              eFellows program.
            </p>
          </div>
          <div className={cn(styles.subSection, styles.centeredSection)}>
            <h1>Credits</h1>
            <p className={styles.centeredParagraph}>
              This application was built with heart and passion by the Ideas
              Come To Life Team.
            </p>
            <div className="credits-image flex justify-center">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src="/images/landing-page/ictlife-credits.jpg"
                alt="ICTLife credits signature list"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
}
